'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["slots", "slotProps", "children"];
import * as React from 'react';
import useSlotProps from '@mui/utils/useSlotProps';
import { useComposerContext } from "./internals/ComposerContext.js";
import { jsx as _jsx } from "react/jsx-runtime";
export const ComposerHelperText = /*#__PURE__*/React.forwardRef(function ComposerHelperText(props, ref) {
  const {
      slots,
      slotProps,
      children
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  const composer = useComposerContext();
  const ownerState = {
    isSubmitting: composer.isSubmitting,
    hasValue: composer.hasValue,
    isStreaming: composer.isStreaming,
    attachmentCount: composer.attachmentCount,
    disabled: composer.disabled,
    error: composer.error != null
  };
  const HelperText = slots?.helperText ?? 'div';
  const rootProps = useSlotProps({
    elementType: HelperText,
    externalSlotProps: slotProps?.helperText,
    externalForwardedProps: other,
    ownerState,
    additionalProps: {
      ref
    }
  });
  const content = children ?? composer.error?.message ?? null;
  if (content == null) {
    return null;
  }
  const resolvedRole = rootProps.role ?? (composer.error ? 'alert' : undefined);
  return /*#__PURE__*/_jsx(HelperText, _extends({}, rootProps, {
    role: resolvedRole,
    children: content
  }));
});
if (process.env.NODE_ENV !== "production") ComposerHelperText.displayName = "ComposerHelperText";